import {Space, Tag, Typography} from "antd";
import s from '../mobile.module.css'
import {
    CalendarOutlined,
    CommentOutlined,
    EnvironmentOutlined,
    InfoCircleOutlined,
    PhoneOutlined,
    UserOutlined
} from "@ant-design/icons";

const {Text, Title} = Typography;

const ObjectDetails = ({object}) => (
    <div className={s.objectDetails}>
        <div className={s.detailItem} style={{textAlign: "left"}}>
            <Tag color={object.access.color} icon={<InfoCircleOutlined/>}>
               Доступ: {object.access.label}
            </Tag>
        </div>
        <div style={{margin: '10px auto', textAlign: "left"}}>
            {object.contact_name && (
                <div className={s.detailItem}>
                    <UserOutlined/> <Text strong>Контакт:</Text> {object.contact_name}
                </div>
            )}
        </div>
        <div style={{margin: '10px auto', textAlign: "left"}}>
        {object.contacts && (
            <div className={s.detailItem}>
                <PhoneOutlined/> <Text strong>Телефон:</Text> {object.contacts}
            </div>
        )}
        </div>
        <div style={{margin: '10px auto', textAlign: "left"}}>

        {object.description && (
            <div className={s.detailItem}>
                <InfoCircleOutlined/> <Text strong>Правила:</Text> {object.description}
            </div>
        )}
        </div>
        <div style={{margin: '10px auto', textAlign: "left"}}>

            {object.comment_last_service && (
                <div className={s.detailItem}>
                    <InfoCircleOutlined/> <Text strong>Заметка с последнего посещения:</Text> {object.comment_last_service}
                </div>
            )}
        </div>



{/*        <Space direction="vertical" size="small" style={{width: '100%'}}>
            <div className={s.detailItem}>
                <Tag color={object.access.color} icon={<InfoCircleOutlined/>}>
                    {object.access.label}
                </Tag>
            </div>

            {object.contact_name && (
                <div className={s.detailItem}>
                    <UserOutlined/> <Text strong>Контакт:</Text> {object.contact_name}
                </div>
            )}

            {object.contacts && (
                <div className={s.detailItem}>
                    <PhoneOutlined/> <Text strong>Телефон:</Text> {object.contacts}
                </div>
            )}

            {object.description && (
                <div className={s.detailItem}>
                    <InfoCircleOutlined/> <Text strong>Правила:</Text> {object.description}
                </div>
            )}

            {object.comment && (
                <div className={s.detailItem}>
                    <CommentOutlined/> <Text strong>Комментарий:</Text> {object.comment}
                </div>
            )}

            {object.locate && (
                <div className={s.detailItem}>
                    <EnvironmentOutlined/> <Text strong>Локация:</Text> {object.locate}
                </div>
            )}

            {object.formattedLastService && (
                <div className={s.detailItem}>
                    <CalendarOutlined/> <Text strong>Посл. обсл.:</Text> {object.formattedLastService}
                </div>
            )}

            {object.comment_last_service && (
                <div className={s.detailItem}>
                    <CommentOutlined/> <Text strong>Коммент обсл.:</Text> {object.comment_last_service}
                </div>
            )}
        </Space>*/}
    </div>
);
export default ObjectDetails